import { render, staticRenderFns } from "./SymbolFeedConfig.vue?vue&type=template&id=11398654&scoped=true"
import script from "./SymbolFeedConfig.vue?vue&type=script&lang=js"
export * from "./SymbolFeedConfig.vue?vue&type=script&lang=js"
import style0 from "./SymbolFeedConfig.vue?vue&type=style&index=0&id=11398654&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11398654",
  null
  
)

export default component.exports